import {
  CohortNavTemplate,
  PageTemplate,
  ProgramNavTemplate,
} from '@efdigital/ll-addon-content';
import AdminLegacyWarning from '@efdigital/ll-admin-v2/components/admin-legacy-warning.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import {
  pageTemplateParts,
  programTemplateParts,
  resourceTemplateParts,
} from '@efdigital/ll-admin-v2/components/parts.gts';
import ContentBreadcrumb from '@efdigital/ll-admin-v2/components/programs/content-breadcrumb.gts';
import { EditPageContent } from '@efdigital/ll-admin-v2/components/programs/edit-page-content.gts';
import { EditPageWidgets } from '@efdigital/ll-admin-v2/components/programs/edit-page-widgets.gts';
import { Sidebar } from '@efdigital/ll-admin-v2/components/sidebar/sidebar.gts';
import type { PageContext } from '@efdigital/ll-admin-v2/lib/page-manager';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type CohortContentPageRoute from '@efdigital/ll-admin-v2/routes/programs/program/cohort/content/page';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { pageTitle } from 'ember-page-title';

interface ContentPageSignature {
  Args: {
    model: ModelFrom<CohortContentPageRoute>;
    controller: unknown;
  };
}

const parts = programTemplateParts;
const partsForPage = {
  ...pageTemplateParts,
  ...resourceTemplateParts,
};

function pageContext(model: ModelFrom<CohortContentPageRoute>): PageContext {
  return {
    type: 'cohort',
    clientId: model.cohort.client?.id || '',
    programId: model.program.id as string,
    cohortId: model.cohort.id as string,
  };
}

const Template: TemplateOnlyComponent<ContentPageSignature> = <template>
  {{pageTitle "Page"}}

  <ContentBreadcrumb @model={{@model}} />

  <div class="mb-5">
    <EditContext as |context|>
      <Sidebar>
        <:content>
          <AdminLegacyWarning
            @item={{@model.page}}
            @itemType="page"
            @programId={{@model.program.id}}
            @cohortId={{@model.cohort.id}}
            class="container"
          />

          <ProgramNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @parts={{parts}}
          />
          <CohortNavTemplate
            @program={{@model.program}}
            @cohort={{@model.cohort}}
            @parts={{parts}}
          >
            <PageTemplate
              @page={{@model.page}}
              @section={{hash path=@model.page.slug}}
              @parts={{partsForPage}}
            />
          </CohortNavTemplate>
        </:content>
        <:sidebar>
          <div class="px-3 py-4">
            <EditPageContent
              @item={{@model.page}}
              @context={{context}}
              class="mb-5"
            />

            <EditPageWidgets
              @item={{@model.page}}
              @context={{context}}
              @pageContext={{pageContext @model}}
              class="mb-5"
            />
          </div>
        </:sidebar>
      </Sidebar>
    </EditContext>
  </div>
</template>;

export default Template;
